/** 站点模式：租户用户站（交易中心随租户域名，无独立 market.* 站） */

export type SiteMode = 'tenant'

export function getSiteMode(): SiteMode {
  return 'tenant'
}

export function isMarketplaceSite(): boolean {
  return false
}

export function isTenantSite(): boolean {
  return true
}

/** @deprecated 租户内集市；保留兼容，始终返回本域路径 */
export function marketplaceSiteUrl(path: string): string {
  return path
}

/** @deprecated 租户内集市；保留兼容，始终返回本域路径 */
export function tenantParticipationUrl(_tenantCode: string, path: string): string {
  return path
}
